import { useTranslation } from 'react-i18next';

import { Modal } from 'components/Modal';
import { AssetsService } from 'services/AssetsService';

import { quotaI18nKeys } from '../i18n';

import {
  StyledNotifyAdminModalContainer,
  StyledNotifyAdminImage,
  StyledNotifyAdminTitle,
  StyledNotifyAdminSubTitle,
} from './styles';

type NotifyAdminSuccessModalProps = {
  isOpen: boolean;
  onClose: VoidFunction;
};

export const NotifyAdminSuccessModal = ({ isOpen, onClose }: NotifyAdminSuccessModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} hasCloseBtn>
      <StyledNotifyAdminModalContainer>
        <StyledNotifyAdminImage src={AssetsService.assetUrl('/images/balloons.svg')} alt="balloons" />
        <StyledNotifyAdminTitle>{t(quotaI18nKeys.notifyAdminSuccessTitle)}</StyledNotifyAdminTitle>
        <StyledNotifyAdminSubTitle>{t(quotaI18nKeys.notifyAdminSuccessDescription)}</StyledNotifyAdminSubTitle>
      </StyledNotifyAdminModalContainer>
    </Modal>
  );
};
